import React from 'react';
import CountUp from 'react-countup';

// Static color palette for counter cards
const CARD_THEMES = {
  blue: { bg: '#EFF6FF', border: '#BFDBFE', icon: '#2563EB', text: '#1E40AF' },
  green: { bg: '#F0FDF4', border: '#BBF7D0', icon: '#16A34A', text: '#166534' },
  orange: { bg: '#FFF7ED', border: '#FED7AA', icon: '#EA580C', text: '#9A3412' },
  purple: { bg: '#FAF5FF', border: '#E9D5FF', icon: '#9333EA', text: '#6B21A8' },
  teal: { bg: '#F0FDFA', border: '#99F6E4', icon: '#0D9488', text: '#115E59' },
  rose: { bg: '#FFF1F2', border: '#FECDD3', icon: '#E11D48', text: '#9F1239' },
};

const AnimatedCounter = ({ value = 0, label, icon: Icon, color = 'blue', suffix = '', prefix = '', onClick }) => {
  const theme = CARD_THEMES[color] || CARD_THEMES.blue;

  return (
    <div
      className={`rounded-xl p-3 sm:p-4 transition-all duration-200 flex flex-col justify-between min-h-[85px] sm:min-h-[95px] min-w-0 overflow-hidden ${onClick ? 'cursor-pointer hover:shadow-md hover:-translate-y-0.5' : ''}`}
      style={{
        backgroundColor: theme.bg,
        border: `1px solid ${theme.border}`,
      }}
      onClick={onClick}
    >
      <div className="flex items-start justify-between gap-1 sm:gap-2">
        <p className="text-xs font-medium text-gray-500 leading-tight min-w-0 truncate">{label}</p>
        {Icon && (
          <div
            className="w-8 h-8 sm:w-10 sm:h-10 rounded-lg flex items-center justify-center flex-shrink-0"
            style={{ backgroundColor: `${theme.icon}15` }}
          >
            <Icon className="w-3.5 h-3.5 sm:w-4 sm:h-4" style={{ color: theme.icon }} />
          </div>
        )}
      </div>
      <div className="flex items-baseline gap-1 mt-2">
        {prefix && <span className="text-base sm:text-lg font-semibold" style={{ color: theme.text }}>{prefix}</span>}
        <CountUp
          end={value}
          duration={2}
          separator=","
          className="text-2xl sm:text-3xl font-bold tabular-nums leading-none"
          style={{ color: theme.text }}
        />
        {suffix && <span className="text-xs sm:text-sm font-medium" style={{ color: theme.text }}>{suffix}</span>}
      </div>
    </div>
  );
};

export default AnimatedCounter;
